import { type Item, type ProductListConfig } from '../models'

import { getIntensityGauge } from '../../common/intensity-gauge'

export const getFavourProfiles = (
  variant: Partial<Item>,
  shopConfig: Partial<ProductListConfig['shopConfig']>,
  visibility: boolean
) => {
  const showFlavourProfiles =
    visibility &&
    (variant?.intensity || variant?.aroma || variant?.body || variant?.cooling)

  const showMultipleProfiles = !shopConfig?.flavourBanEnabled

  const flavourProfiles = [
    {
      label: shopConfig?.intensityLabel,
      value: parseInt(variant?.intensity ?? '', 10),
      scale: 5
    },
    {
      label: shopConfig?.aromaLabel,
      value: parseInt(variant?.aroma ?? '', 10),
      scale: 5
    },
    {
      label: shopConfig?.bodyLabel,
      value: parseInt(variant?.body ?? '', 10),
      scale: 5
    },
    {
      label: shopConfig?.coolingLabel,
      value: parseInt(variant?.cooling ?? '', 10),
      scale: 5
    }
  ].filter(({ value }) => Boolean(value))

  return showFlavourProfiles
    ? {
        profiles: showMultipleProfiles
          ? flavourProfiles
          : getIntensityGauge(variant, shopConfig?.intensityLabel),
        showMultipleProfiles
      }
    : undefined
}
